var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeightReconcillation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.043 45.7529H10.5283C9.91724 45.7529 9.42188 46.2559 9.42188 46.8764C9.42188 47.4969 9.91724 47.9999 10.5283 47.9999H13.043C13.654 47.9999 14.1494 47.4969 14.1494 46.8764C14.1494 46.2559 13.654 45.7529 13.043 45.7529Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0742 45.7529H37.5596C36.9485 45.7529 36.4531 46.2559 36.4531 46.8764C36.4531 47.4969 36.9485 47.9999 37.5596 47.9999H40.0742C40.6853 47.9999 41.1807 47.4969 41.1807 46.8764C41.1807 46.2559 40.6853 45.7529 40.0742 45.7529Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48438 40.3544V10.3438H6.93616V40.3544H5.48438Z",
    fill: "url(#paint0_linear_1408_8029)",
    stroke: "#7939CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2077 12.6083C9.63612 12.6083 12.4154 9.7858 12.4154 6.30413C12.4154 2.82246 9.63612 0 6.2077 0C2.77928 0 0 2.82246 0 6.30413C0 9.7858 2.77928 12.6083 6.2077 12.6083Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.20604 11.6307C9.10283 11.6307 11.4511 9.2459 11.4511 6.30412C11.4511 3.36233 9.10283 0.977539 6.20604 0.977539C3.30925 0.977539 0.960938 3.36233 0.960938 6.30412C0.960938 9.2459 3.30925 11.6307 6.20604 11.6307Z",
    fill: "#7939CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4511 6.30371C11.4511 9.24554 9.10256 11.6303 6.20604 11.6303C3.30951 11.6303 0.960938 9.24523 0.960938 6.30371H3.72145C3.72145 7.69716 4.8339 8.82689 6.20604 8.82689C7.57817 8.82689 8.69062 7.69716 8.69062 6.30371H11.4511Z",
    fill: "url(#paint1_linear_1408_8029)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01565 7.26542C7.01565 7.71707 6.65517 8.08316 6.21043 8.08316C5.76569 8.08316 5.4052 7.71707 5.4052 7.26542C5.4052 6.90942 5.62938 6.60629 5.94202 6.49414V3.12756H5.29688L6.21043 1.52051L7.12398 3.12756H6.47883V6.49414C6.79178 6.60629 7.01565 6.90912 7.01565 7.26542Z",
    fill: "url(#paint2_linear_1408_8029)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3549 39.5437H12.8549V39.0437V38.4668H13.2274V39.0437V39.5437H13.7274H39.2361H39.7361V39.0437V38.4668H40.1082V39.0437V39.5437H40.6082H45.9397C46.7953 39.5437 47.5015 40.2497 47.5015 41.1375V44.5328C47.5015 45.4203 46.7952 46.1266 45.9397 46.1266H4.59306C3.73781 46.1266 3.03125 45.4203 3.03125 44.5328V41.1375C3.03125 40.2498 3.73776 39.5437 4.59306 39.5437H12.3549Z",
    fill: "url(#paint3_linear_1408_8029)",
    stroke: "#7939CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4785 38.2683H9.56591C9.17143 38.2683 8.85156 37.9434 8.85156 37.5428C8.85156 37.1422 9.17143 36.8174 9.56591 36.8174H42.4788C42.8732 36.8174 43.1931 37.1422 43.1931 37.5428C43.1931 37.9434 42.8732 38.2683 42.4788 38.2683H42.4785Z",
    fill: "#7939CC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6395 34.1832L41.6395 34.1833C41.3747 35.3246 40.3673 36.1652 39.1764 36.1652H15.8279C14.6374 36.1652 13.6299 35.3247 13.3649 34.1832L13.3648 34.183C13.3205 33.9923 13.2969 33.7929 13.2969 33.5871V11.8141C13.2969 10.383 14.437 9.23633 15.8276 9.23633H38.9381H38.9387C40.4608 9.23633 41.7075 10.4915 41.7075 12.0558V33.5871C41.7075 33.7928 41.6839 33.992 41.6395 34.1832Z",
    stroke: "#7939CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0944 8.73535V18.6349C25.0944 18.9995 25.2632 19.1877 25.3661 18.9384L27.39 14.039C27.452 13.8884 27.5485 13.8884 27.6105 14.039L29.6347 18.9384C29.7376 19.1877 29.9064 18.9992 29.9064 18.6349V8.73535H25.0938H25.0944Z",
    fill: "#7939CC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7921 27.502H16.2529C15.8328 27.502 15.4922 27.8478 15.4922 28.2745V31.256C15.4922 31.6827 15.8328 32.0285 16.2529 32.0285H19.7921C20.2123 32.0285 20.5528 31.6827 20.5528 31.256V28.2745C20.5528 27.8478 20.2123 27.502 19.7921 27.502Z",
    fill: "#7939CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6293 28.4883H32.8318C32.6917 28.4883 32.5781 28.6036 32.5781 28.7459V28.9222C32.5781 29.0645 32.6917 29.1798 32.8318 29.1798H39.6293C39.7694 29.1798 39.8829 29.0645 39.8829 28.9222V28.7459C39.8829 28.6036 39.7694 28.4883 39.6293 28.4883Z",
    fill: "#7939CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8318 30.3506H39.6296C39.7695 30.3506 39.8832 30.4661 39.8832 30.6082V30.7848C39.8832 30.9269 39.7695 31.0424 39.6296 31.0424H32.8318C32.6919 31.0424 32.5781 30.9269 32.5781 30.7848V30.6082C32.5781 30.4661 32.6919 30.3506 32.8318 30.3506Z",
    fill: "#7939CC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1408_8029",
    x1: 6.21027,
    y1: 9.84375,
    x2: 6.21027,
    y2: 40.8544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4656A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7939CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1408_8029",
    x1: 6.20604,
    y1: 6.30371,
    x2: 6.20604,
    y2: 11.6303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4656A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7939CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1408_8029",
    x1: 6.21043,
    y1: 1.52051,
    x2: 6.21043,
    y2: 8.08316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7939CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4656A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1408_8029",
    x1: 46.5841,
    y1: 42.3706,
    x2: 2.39435,
    y2: 42.3706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4656A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7939CC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightReconcillation);
export default __webpack_public_path__ + "static/media/WeightReconcillation.64243267fb30ef10f205b1f25009ac38.svg";
export { ForwardRef as ReactComponent };